import { Grid } from "@mui/material";
import CallActivityPerformance from "./CallActivityPerformance";
import { ICallActivityPerformance, IPhoneObject } from "@/Settings/types/Common/model";
import CommonDivider from "../../../common/CommonDivider";
import CallActivityBlackList from "./CallActivityBlackList";

type TCallActivityProps = {
	locationId: string;
	callActivityPerformance?: ICallActivityPerformance;
	phoneNumbers?: IPhoneObject[];
};

const CallActivity = (props: TCallActivityProps) => {
	const { locationId, callActivityPerformance, phoneNumbers } = props;
	return (
		<Grid container direction={"column"}>
			<CallActivityPerformance locationId={locationId} callActivityPerformance={callActivityPerformance} />
			<CommonDivider className="!ml-0" />
			<CallActivityBlackList locationId={locationId} phoneNumbers={phoneNumbers} />
		</Grid>
	);
};

export default CallActivity;
